import { errorMessagesSection, faExclamationCircle, FormStyle, infoPlaceholderSection, React, SelectStyle } from "@/imports-files/components/custom-select";
import { Field } from "@/imports-files/components/input";
import { getIn } from "formik";

export function CustomTextarea(props)
{
  const error = getIn(props.formik.errors, props.name);
  const touched = getIn(props.formik.touched, props.name);
return(
       <div>
       {props.onChange ?
        <Field
            component  =    "textarea" 
            name       =    {props.name}
            style      =    {props.style}
            rows       =    {props.rows}
            className  =    {props.className}
            placeholder=    {props.placeholder}
            disabled   =   {props.disabled}
            onChange   =   {props.onChange}
            defaultValue= {props.defaultValue}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
         />
         : <Field
            component  =    "textarea" 
            name       =    {props.name}
            style      =    {props.style}
            rows       =    {props.rows}
            className  =    {props.className}
            placeholder=    {props.placeholder}
            disabled   =   {props.disabled}
            defaultValue= {props.defaultValue}
            placeholder={props.placeholder}
            maxLength={props.maxLength}
         />}

           {
              touched && error ? errorMessagesSection( props.name, FormStyle, props.formik, props.custom_class || '', props?.custom_error_90 || '', props.customFontFamily)
                                      :  infoPlaceholderSection( props.infoPlaceholder, FormStyle)
           }

       </div>
     )
}



